var urlLEM = window.location.href;





function myPopup(myURL, title, myWidth, myHeight) {
    var left = (screen.width - myWidth) / 2;
    var top = (screen.height - myHeight) / 4;
    var myWindow = window.open(myURL, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + myWidth + ', height=' + myHeight + ', top=' + top + ', left=' + left);
    }

function whatsapp(text) {
window.open
('whatsapp://send?text='+text+'');
}    



$(document).on('click','.bam_facebook', function (){ 
    var getText = $("#article_header").html();
    var getTextEscape = encodeURI(getText);
    var getURL = window.location.href;
    myPopup('https://www.facebook.com/sharer/sharer.php?u='+getURL,'',375,400); 
});

$(document).on('click','.si-facebook', function (){ 
    var getText = $("#article_header").html();
    var getTextEscape = encodeURI(getText);
    var getURL = window.location.href;
    myPopup('https://www.facebook.com/sharer/sharer.php?u='+getURL,'',375,400); 
});

$(document).on('click','.bam_twitter', function (){ 
    var getText = $("#article_header").html();
    var getTextEscape = encodeURI(getText);
    var getURL = window.location.href;
    myPopup('https://twitter.com/intent/tweet?url='+getURL+'&text='+getTextEscape+'',getTextEscape,375,400);
   
});

$(document).on('click','.si-twitter', function (){ 
    var getText = $("#article_header").html();
    var getTextEscape = encodeURI(getText);
    var getURL = window.location.href;
    myPopup('https://twitter.com/intent/tweet?url='+getURL+'&text='+getTextEscape+'',getTextEscape,375,400);
   
});





$('#copyClickMobile').attr("data-clipboard-text",urlLEM);
var clipboard = new ClipboardJS('#copyClickMobile');

clipboard.on('success', function(e) {
    console.info('Action:', e.action);
    console.info('Text:', e.text);
    console.info('Trigger:', e.trigger);
    
    e.clearSelection();
    alert("This Article's link has been copied to clipboard");
});


$('#copyClick').attr("data-clipboard-text",urlLEM);
var clipboard = new ClipboardJS('#copyClick');

clipboard.on('success', function(e) {
    console.info('Action:', e.action);
    console.info('Text:', e.text);
    console.info('Trigger:', e.trigger);
    
    e.clearSelection();
    alert("This Article's link has been copied to clipboard");
});


clipboard.on('error', function(e) {
    console.error('Action:', e.action);
    console.error('Trigger:', e.trigger);
});


$(document).on('click','.si-copy', function (){ 

});
